import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            为什么选择屁屁影院
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            五大核心优势，给你最好的在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 text-center cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-xl md:text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}